module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner01-650f970e61392d677d61c29bf150d25b.png";